import type { TagsManager } from 'dxf-writer'
import DatabaseObject from 'dxf-writer/src/DatabaseObject.js'
import type Handle from 'dxf-writer/src/Handle.js'

/** DXF 线性标注的单位展示配置。 */
export interface DxfDimensionStyleOptions {
  /** 主单位测量倍率（DIMLFAC）。 */
  lengthFactor: number
  /** 主单位精度（DIMDEC）。 */
  precision: number
  /** 线性单位格式（DIMLUNIT）。 */
  linearUnitFormat: 2 | 4
  /** 分数格式（DIMFRAC），仅 Architectural 使用。 */
  fractionFormat?: 2
}

/**
 * DXF 标注样式（DIMSTYLE）表记录，供 DIMSTYLE 表段输出时使用。
 */
export default class DimStyle extends DatabaseObject {
  /** 记录句柄，组码 105 */
  declare handle: Handle
  /** 所有者对象句柄，组码 330 */
  declare ownerObjectHandle: Handle
  /** 子类标记链，用于组码 100 */
  declare subclassMarkers: string[]

  constructor(
    public name: string,
    public textStyleHandle: Handle,
    public unitOptions?: DxfDimensionStyleOptions
  ) {
    super(['AcDbSymbolTableRecord', 'AcDbDimStyleTableRecord'])
  }

  /**
   * 写入 DIMSTYLE 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager: TagsManager) {
    manager.push(0, 'DIMSTYLE')
    manager.push(105, this.handle) // DIMSTYLE 记录特有的句柄（Handle）组码 (普通对象使用 5， 样式记录使用 105)
    manager.push(330, this.ownerObjectHandle)
    for (const s of this.subclassMarkers) {
      manager.push(100, s)
    }
    manager.push(2, this.name)
    manager.push(70, 0) // flags
    manager.push(340, this.textStyleHandle)
    if (this.unitOptions) {
      manager.push(144, this.unitOptions.lengthFactor) // DIMLFAC
      manager.push(271, this.unitOptions.precision) // DIMDEC
      if (this.unitOptions.fractionFormat !== undefined) {
        manager.push(276, this.unitOptions.fractionFormat) // DIMFRAC
      }
      manager.push(277, this.unitOptions.linearUnitFormat) // DIMLUNIT
    }
    // manager.push(40, 1.0);// DIMSCALE
    // manager.push(41, 2.5);// DIMASZE 箭头大小
    // manager.push(77, 1);// DIMTAD 垂直放置文字
    // manager.push(140, 2.5);// DIMTXT 文字高度
    // manager.push(141, 0.1);
    // manager.push(172, 1);
    // manager.push(174, 1);// DIMTIX 文字界内对齐
    // manager.push(271, 2);
  }
}
